import Vue from "vue";
import Vuex from "vuex";

import Properties from "./properties";
import Generic from "./generic";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    Properties,
    Generic
  },
  state: {},
  mutations: {},
  actions: {}
});
